module.exports = __webpack_public_path__ + "media/images/pagetitles/videos-7d3e0bb8e6958f57e2e6fa8c8736df13.gif";